@if (editLink() && entityTypeLabelKey()) {
    <a
        [routerLink]="editLink()"
        class="text-primary hover:underline truncate block max-w-full"
        [pTooltip]="linkTooltip() | translate: linkTooltipParams()"
        [attr.aria-label]="linkTooltip() | translate: linkTooltipParams()"
    >
        {{ entityTypeLabelKey() | translate }}@if (entityLabel()) {: {{ entityLabel() }}}
    </a>
}
